const getPresentedEvent = ({payload}) => ({
    eventName: 'multi_armed_bandit.presented',
    payload,
});

const getSelectedEvent = ({payload}, event) => ({
    eventName: 'multi_armed_bandit.selected',
    payload: {
        ...payload,
        reward_event_id: event.edapEventType,
    },
});

const getEventOptions = (mab, event) => {
    return event.type === 'PRESENT'
        ? getPresentedEvent(mab)
        : getSelectedEvent(mab, event);
};

const isTargetEvent = (filter, edapEvent) => {
    if (filter) {
        const [key, value] = filter.split(':');
        if (!edapEvent[key] || edapEvent[key].indexOf(value) === -1) {
            return false;
        }
    }
    return true;
};

const formatEventProperties = (store) => {
    const moduleStatus = store.getState().moduleStatus.modules;
    return Object.entries(moduleStatus).map(([name, value]) => ({name, value}));
};

const edapTrigger = (edap, eventName, payload, edapEvent, store) => {
    const isSelectedEvent = eventName.includes('selected');
    const eventProperties = formatEventProperties(store);
    const data = {
        ...payload,
        visitor_id: edapEvent.visitorid,
        ...(isSelectedEvent
            ? {event_properties: JSON.stringify(eventProperties)}
            : {}),
    };
    edap.trigger(eventName, data);
};

const dispatch = (edap, {eventName, payload}, filter, store) => (edapEvent) => {
    if (!isTargetEvent(filter, edapEvent)) {
        return;
    }

    const manyExposures = (edapEvent.testname || '').includes(',');
    if (!manyExposures) {
        edapTrigger(edap, eventName, payload, edapEvent, store);
    }
};

const subscribe = (mabContext, edap, store) => {
    const {events} = mabContext;

    try {
        events.forEach((event) =>
            edap.on(
                event.edapEventType,
                dispatch(
                    edap,
                    getEventOptions(mabContext, event),
                    event.filter,
                    store
                )
            )
        );
    } catch (error) {
        return;
    }
};

/**
 * Registers a list of events based on provided mabContext.
 * If passed edap object is not initialized, it pushes a new function to wait
 * for EDAP to callback once ready
 * @param {object | Array} edap - edap object or array
 * @param {object} mabContext - Mab context data from initial state
 */
export const register = (edap, mabContext = {}, store) => {
    if (!edap || !mabContext.arm) {
        return;
    }

    if (!edap.on && !edap.off) {
        edap.push((edapInstance) => subscribe(mabContext, edapInstance, store));
    } else {
        subscribe(mabContext, edap, store);
    }
};
